import { render, staticRenderFns } from "./Percentage.vue?vue&type=template&id=fe3f428e"
import script from "./Percentage.vue?vue&type=script&lang=js"
export * from "./Percentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports